import { logEvent as firebaseLogEvent } from "firebase/analytics";

/**
 * Logs an event to all configured analytics providers (Firebase, Telegram).
 * @param {import("firebase/analytics").Analytics | null} firebaseAnalyticsInstance - The Firebase Analytics instance.
 * @param {string} eventName - The name of the event.
 * @param {object} [eventParams] - The parameters for the event.
 */
export function logEvent(firebaseAnalyticsInstance, eventName, eventParams) {
  // 1. Log to Firebase Analytics
  if (firebaseAnalyticsInstance) {
    try {
      firebaseLogEvent(firebaseAnalyticsInstance, eventName, eventParams);
      console.log(`Analytics (Firebase): Logged '${eventName}'`, eventParams || {});
    } catch (error) {
      console.error("Firebase Analytics logEvent failed:", error);
    }
  }

  // 2. Log to Telegram Mini App Analytics
  if (
    window.telegramAnalytics &&
    typeof window.telegramAnalytics.logEvent === "function"
  ) {
    try {
      window.telegramAnalytics.logEvent(eventName, eventParams || {});
      console.log(
        `Analytics (Telegram): Logged '${eventName}'`,
        eventParams || {}
      );
    } catch (error) {
      console.error("Telegram Analytics logEvent failed:", error);
    }
  }
}
